module.exports = __webpack_public_path__ + "assets/images/project/icon-ar.svg?v=02010491";